/* FF-SCROLL — the fun-to-scroll layer (see ff-scroll.css). 31 Oct 2026.
   One passive scroll listener, one rAF loop. Decoration only: nothing on the
   page depends on this file, and prefers-reduced-motion skips the motion. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var doc = document.documentElement;

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    /* ── Progress line ───────────────────────────────────────────── */
    var bar = document.createElement('div');
    bar.className = 'ffs-progress';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<i></i>';
    document.body.insertBefore(bar, document.body.firstChild);
    var barFill = bar.firstChild;

    /* ── Word bands: speed up while scrolling ───────────────────── */
    var tracks = [].slice.call(document.querySelectorAll('.ffs-band-track'));
    var anims = [];
    if (!reduce && tracks.length && tracks[0].getAnimations) {
      tracks.forEach(function (t) { var a = t.getAnimations(); if (a[0]) anims.push(a[0]); });
    }

    /* ── Scroll hint fades once you start ───────────────────────── */
    var hint = document.querySelector('.ffs-hint');

    var lastY = window.scrollY, boost = 0, ticking = false;
    function frame() {
      ticking = false;
      var y = window.scrollY;
      var max = Math.max(1, doc.scrollHeight - window.innerHeight);
      barFill.style.transform = 'scaleX(' + Math.min(1, y / max).toFixed(4) + ')';
      var v = Math.abs(y - lastY); lastY = y;
      boost = Math.max(boost * 0.9, Math.min(v / 6, 6));
      if (anims.length) {
        var rate = 1 + boost;
        for (var i = 0; i < anims.length; i++) anims[i].playbackRate = rate;
        if (boost > 0.05) { ticking = true; requestAnimationFrame(frame); }
      }
      if (hint && y > 140 && !hint.classList.contains('is-gone')) hint.classList.add('is-gone');
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(frame); }
    }, { passive: true });
    frame();

    /* ── Chapter numbers on the homepage section labels ─────────── */
    if (document.body.classList.contains('template-index') || document.querySelector('[data-ffs-home]')) {
      var labels = [].slice.call(document.querySelectorAll(
        'main .shop-sec-header .eyebrow, main .ffh-kicker, main .ffw-chapter, main .bundle-header .eyebrow,' +
        'main .harud-eyebrow, main .process .section-head .eyebrow, main .reviews .section-head .eyebrow'
      ));
      var n = 0;
      labels.forEach(function (el) {
        if (el.closest('.ffh-oil') || el.closest('.ffh-nutta')) return; // inside a chapter, not a new one
        if (!el.offsetParent) return;
        n += 1;
        var num = (n < 10 ? '0' : '') + n;
        var old = el.querySelector(':scope > b');
        if (el.classList.contains('ffw-chapter') && old) old.remove();
        var b = document.createElement('b');
        b.className = 'ffs-n';
        b.setAttribute('aria-hidden', 'true');
        b.textContent = num;
        el.insertBefore(b, el.firstChild);
      });
    }

    /* ── Count-up numbers ───────────────────────────────────────── */
    var counters = [].slice.call(document.querySelectorAll('.ffh-facts dt, .ffh-spec dt, .ffh-jar-stat, [data-ffs-count]'));
    function firstText(el) {
      for (var i = 0; i < el.childNodes.length; i++) {
        var c = el.childNodes[i];
        if (c.nodeType === 3 && /\d/.test(c.textContent)) return c;
      }
      return null;
    }
    if (!reduce && 'IntersectionObserver' in window && counters.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.unobserve(e.target);
          var node = firstText(e.target);
          if (!node) return;
          var txt = node.textContent;
          var m = txt.match(/^(\D*)([\d,]+(?:\.\d+)?)(.*)$/);
          if (!m) return;
          var target = parseFloat(m[2].replace(/,/g, ''));
          if (!(target > 1)) return;
          var comma = m[2].indexOf(',') > -1, t0 = null, dur = 1100;
          function step(ts) {
            if (!t0) t0 = ts;
            var p = Math.min(1, (ts - t0) / dur), ease = 1 - Math.pow(1 - p, 3);
            var val = Math.round(target * ease);
            node.textContent = m[1] + (comma ? val.toLocaleString('en-IN') : String(val)) + m[3];
            if (p < 1) requestAnimationFrame(step); else node.textContent = txt;
          }
          requestAnimationFrame(step);
        });
      }, { threshold: 0.6 });
      counters.forEach(function (c) { io.observe(c); });
    }

    /* ── Jar calculator ─────────────────────────────────────────── */
    [].slice.call(document.querySelectorAll('[data-ffs-calc]')).forEach(function (card) {
      var range = card.querySelector('.ffs-range');
      var spoonsOut = card.querySelector('.ffs-calc-spoons');
      var daysOut = card.querySelector('[data-ffs-days]');
      var walnutOut = card.querySelector('[data-ffs-walnut]');
      var big = card.querySelector('.ffs-calc-big');
      var segs = [].slice.call(card.querySelectorAll('.ffs-seg-btn'));
      var spoonG = parseFloat(card.getAttribute('data-spoon')) || 16;
      var walnut = parseFloat(card.getAttribute('data-walnut')) || 0.8;
      var jar = 480;
      function render() {
        var s = parseInt(range.value, 10) || 1;
        var days = Math.floor(jar / (s * spoonG));
        var week = Math.round(s * spoonG * walnut * 7);
        spoonsOut.textContent = String(s);
        daysOut.textContent = String(days);
        walnutOut.textContent = week + ' g';
        if (!reduce && big) {
          big.classList.remove('is-bump'); void big.offsetWidth; big.classList.add('is-bump');
          clearTimeout(big._t); big._t = setTimeout(function () { big.classList.remove('is-bump'); }, 260);
        }
      }
      range.addEventListener('input', render);
      segs.forEach(function (b) {
        b.addEventListener('click', function () {
          jar = parseInt(b.getAttribute('data-g'), 10) || 480;
          segs.forEach(function (o) { var on = o === b; o.classList.toggle('is-on', on); o.setAttribute('aria-checked', on ? 'true' : 'false'); });
          render();
        });
        b.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
          e.preventDefault();
          var i = segs.indexOf(b), nx = segs[(i + (e.key === 'ArrowRight' ? 1 : segs.length - 1)) % segs.length];
          nx.focus(); nx.click();
        });
      });
      render();
    });
  });
})();
